import { Box } from "@chakra-ui/react";
import { MotionFlex as Flex, appearBelow } from "utils/motion";
import Text from "components/base/Text";
import Container from "components/base/Container";
import Image from "components/base/Image";

export default function TextColumns({ title, description, image, inverted, bg, imageWidth, imageHeight, ...props }) {
  return (
    <Box width="100%" bg={bg || (inverted ? "black.900" : "white")}>
      <Container centerContent {...props}>
        <Flex
          variants={appearBelow}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          width="100%"
          flexDirection={["column", null, "row"]}
          alignItems="top"
        >
          <Box
            width={["100%", null, "40%"]}
            mr={[0, null, 8, 20]}
            mb={[4, null, 0]}
          >
            {image ? (
              <Image
                src={image}
                width={imageWidth || "100%"}
                height={imageHeight || "100px"}
              />
            ) : (
              <Text type="headline_md" color={inverted ? "white" : "black.900"}>
                {title}
              </Text>
            )}
          </Box>
          <Box width={["100%", null, "60%"]}>
            {image ? (
              <Text
                type="headline_md"
                mb={[4, null, 8]}
                color={inverted ? "white" : "black.900"}
              >
                {title}
              </Text>
            ) : null}
            <Text type="p_md" color={inverted ? "white" : "black.900"}>
              {description}
            </Text>
          </Box>
        </Flex>
      </Container>
    </Box>
  );
}
